import { html, rune, View } from 'rune-ts';
import klass from './MotionSection.module.scss';
import { typoPcMo } from '../../../../../shared/typography/typo';

export class MotionSection extends View {
  constructor() {
    super({});
  }

  override template() {
    const is_mobile = !!rune.getSharedData(this)?.is_mobile;

    const texts = {
      motion_title: html.preventEscape(ET('mps2::landing::plus::motion_title')),
      motion_description: html.preventEscape(
        ET(`mps2::landing::plus::${is_mobile ? 'mo_' : ''}motion_description`),
      ),
    };

    return html`
      <section class="${klass.motion}">
        <div class="${klass.video_container}">
          <div class="${klass.video_wrapper}">
            <video
              autoplay=""
              loop=""
              muted=""
              playsinline=""
              class="${klass.motion_video}"
              src="//s3.marpple.co/files/u_14345/2024/6/original/plus/section1/${is_mobile
                ? 'mo-'
                : ''}plus-motion-video.mp4"
            ></video>
            <div class="${klass.background}"></div>
          </div>
        </div>

        <div class="${klass.motion_description}">
          <div class="${klass.title} ${typoPcMo({ is_mobile, pc: '48_bold', mo: '28_bold' })}">
            ${texts.motion_title}
          </div>
          <div class="${klass.description} ${typoPcMo({ is_mobile, pc: '20_bold', mo: '14_regular' })}">
            ${texts.motion_description}
          </div>
        </div>
      </section>
    `;
  }
}
